import type { IntlService } from 'ember-intl';
import {
  PUSH_ERROR_CODES,
  PUSH_ERROR_CODES_TRANSLATION_KEY_MAPPING,
} from 'lumen/utils/constants/pricing-assistant-constants';

export function getPushErrorTranslation(
  message: string | null | undefined,
  intl: IntlService,
): string {
  if (!message) {
    return '';
  }
  const hasPushErrorCode = Object.values(PUSH_ERROR_CODES).includes(message);
  if (hasPushErrorCode && PUSH_ERROR_CODES_TRANSLATION_KEY_MAPPING[message]) {
    return intl.t(PUSH_ERROR_CODES_TRANSLATION_KEY_MAPPING[message]);
  }
  return '';
}
